import React, { Suspense } from 'react'

import PropTypes from 'prop-types'
import { useConnect } from 'redux-bundler-hook'

import SpinnerDialog from '~/src/Dialog/Routes/SpinnerDialog'
import { Allowed } from '~/src/Flags'
import createLogger from '~/src/Lib/Logging'
import { idPropType } from '~/src/Lib/PropTypes'
import { EMPTY_OBJECT } from '~/src/Lib/Utils'

const displayName = 'DialogRoute'
const logger = createLogger(displayName)

const Route = ({ dialogRoute, params = EMPTY_OBJECT, doCloseDialogRoute }) => {
  const { additionalProps, Component, ...allowedProps } = dialogRoute

  return (
    <Allowed {...allowedProps}>
      <Component {...params} {...additionalProps} open onClose={doCloseDialogRoute} />
    </Allowed>
  )
}
Route.displayName = displayName
Route.propTypes = {
  dialogRoute: PropTypes.shape({
    /** additionalProps can have any property of any type */
    // eslint-disable-next-line react/forbid-prop-types
    additionalProps: PropTypes.object,
    Component: PropTypes.elementType.isRequired,
  }).isRequired,
  params: PropTypes.shape({
    action: PropTypes.string,
    id: idPropType,
    schema: PropTypes.string,
  }),
  doCloseDialogRoute: PropTypes.func.isRequired
}

const Connected = () => {
  const {
    dialogRouteInfo = EMPTY_OBJECT,
    doCloseDialogRoute
  } = useConnect('selectDialogRouteInfo', 'doCloseDialogRoute')
  const { value: dialogRoute, params } = dialogRouteInfo

  return dialogRoute?.Component ? (
    <Suspense fallback={<SpinnerDialog />}>
      <Route dialogRoute={dialogRoute} params={params} doCloseDialogRoute={doCloseDialogRoute} />
    </Suspense>
  ) : null
}

export default Connected
